import { gql } from 'apollo-angular'

export default gql`
  query downloadImgaesQuery($studyId: Int!, $userId: Int!) {
    downloadStudyImages(data: { studyId: $studyId, userId: $userId })
  }
`
